import { Base64 } from 'js-base64';

import { ausrehabApi as baseApi } from '../baseApi';
import type { EmailTemplateProps } from '../../models';

const emailTemplateApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getEmailTemplates: builder.query<EmailTemplateProps[], void>({
			query: () => ({
				url: 'email-templates',
			}),
			providesTags: ['EmailTemplates'],
		}),

		getEmailTemplate: builder.query<EmailTemplateProps, string>({
			query: (id) => ({
				url: `email-templates/${id}`,
			}),
			transformResponse: (response: EmailTemplateProps) => {
				let bodyHtml = '';

				try {
					bodyHtml = Base64.decode(response.bodyHtml);
				} catch (err) {
					console.error(`${response.id} email template not encoded correctly`);
				}

				return {
					...response,
					bodyHtml,
				};
			},
			providesTags: ['EmailTemplates'],
		}),

		updateEmailTemplate: builder.mutation({
			query: ({ id, bodyHtml, name, subject }) => {
				return {
					url: `email-templates/${id}`,
					method: 'PUT',
					body: {
						bodyHtml: Base64.encode(bodyHtml),
						name,
						subject,
					},
				};
			},
			invalidatesTags: ['EmailTemplates'],
		}),

		addEmailTemplate: builder.mutation({
			query: ({ bodyHtml, name, subject }) => {
				return {
					url: 'email-templates',
					method: 'POST',
					body: {
						bodyHtml: Base64.encode(bodyHtml),
						name,
						subject,
					},
				};
			},
			invalidatesTags: ['EmailTemplates'],
		}),

		delEmailTemplate: builder.mutation({
			query: (id) => ({
				url: `email-templates/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['EmailTemplates'],
		}),
	}),
	overrideExisting: false,
});

export const {
	useGetEmailTemplatesQuery,
	useGetEmailTemplateQuery,

	// mutation
	useUpdateEmailTemplateMutation,
	useAddEmailTemplateMutation,
	useDelEmailTemplateMutation,
} = emailTemplateApi;
